export enum ActionRecaptcha {
    LOGIN = "LOGIN"
}
